import { FC, useCallback, useState } from 'react';
import styles from './index.less';
import { Button, message, Space } from 'antd';
import { PlusSquareOutlined } from '@ant-design/icons';
import cx from 'classnames';
import {
  closestCenter,
  DndContext,
  DragEndEvent,
  MouseSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import SortableItem from '@/pages/backend/cardCampSettings/recruitPageSettings/SortableItem';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import ImageModule from '@/pages/backend/cardCampSettings/recruitPageSettings/ImageModule';
import { editRecruitPageById, getCampInfoById } from '@/services/ConsoleRequest';
import { useRequest, useUpdateEffect } from 'ahooks';
import { useParams } from 'umi';
import { cloneDeep, isEmpty } from 'lodash';
import { PromotionalImagesObj, RecruitPageType } from '@/pages/backend/cardCamp/index';

const RecruitPageSettings: FC = () => {
  const { id: campId } = useParams<{ id: string }>();
  const [dataSource, setDataSource] = useState<(PromotionalImagesObj & { id: number })[]>([
    { id: 1, name: '123', mode: 'dynamicCommunication', index: 1 },
  ]);
  const {} = useRequest(
    () => {
      return getCampInfoById(campId);
    },
    {
      onSuccess: (res) => {
        console.log('获取信息');
        console.log(res);
        if (res?.code === 200 && res?.data) {
          let dynamicObj;
          const { recruitPage } = res.data;
          if (recruitPage.dynamicCommunication) {
            dynamicObj = {
              index: recruitPage.dynamicCommunication.index,
              checked: recruitPage.dynamicCommunication.dynamicCommunication,
              name: '动态交流',
              mode: 'dynamicCommunication',
            };
          }
          let promotionalImagesArray: PromotionalImagesObj[] = [];
          if (Array.isArray(recruitPage.promotionalImages)) {
            promotionalImagesArray = recruitPage.promotionalImages.map((item) => {
              return {
                index: item.index,
                name: item.name,
                mode: 'promotionalImages',
                pcUrl: item.pcUrl,
                mobileUrl: item.mobileUrl,
              };
            });
          }
          if (!isEmpty(dynamicObj) && !isEmpty(promotionalImagesArray)) {
            promotionalImagesArray.push(dynamicObj);
            promotionalImagesArray.sort((a, b) => a.index - b.index);
            const res = promotionalImagesArray.map((item, index) => {
              return {
                id: index + 1,
                name: item.name,
                mode: item.mode,
                pcUrl: item.pcUrl,
                mobileUrl: item.mobileUrl,
                index: index + 1,
                checked: item.checked,
              };
            });
            console.log('res是', res);
            setDataSource(res);
          }
        }
      },
    },
  );
  const { runAsync: doUpdate } = useRequest(
    (params: any) => {
      return editRecruitPageById(campId, params);
    },
    {
      manual: true,
    },
  );
  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 5,
      },
    }),
  );

  const handleDragEnd = useCallback(
    (event: DragEndEvent) => {
      const { active, over } = event;
      const ids = dataSource.map((item) => item.id);
      const oldIndex = ids.indexOf(active.id as number);
      const newIndex = ids.indexOf(over!.id as number);
      if (active.id !== over?.id) {
        const a = arrayMove(dataSource, oldIndex, newIndex);
        setDataSource(a);
      }
    },
    [dataSource],
  );
  useUpdateEffect(() => {
    console.log('dataSource变化');
    console.log(dataSource);
    const cloneDataSource = cloneDeep(dataSource).map((item, index) => {
      return {
        ...item,
        index,
      };
    });
    const dynamicCommunicationItem = cloneDataSource.find(
      (item) => item.mode === 'dynamicCommunication',
    );
    if (dynamicCommunicationItem) {
      let res: RecruitPageType = {
        recruitPage: {
          dynamicCommunication: {
            mode: '',
            dynamicCommunication: dynamicCommunicationItem.checked || false,
            index: dynamicCommunicationItem.index,
          },
          promotionalImages: cloneDataSource.filter((item) => item.mode === 'promotionalImages'),
        },
      };
      doUpdate(res.recruitPage);
    }
  }, [dataSource]);
  return (
    <div className={styles.recruit_page}>
      <div className={styles.button_wrapper}>
        <div className={styles.tips}>
          <div>1.打卡营招生页支持通过上传图片来自定义宣传内容，最多支持上传10组宣传图</div>
          <div>2.PC和移动端需要分别上传图片，建议移动端单独进行设计以保证移动端查看效果</div>
          <div>
            3.PC端每个图片区域宽度为1200px，高度自适应，移动端每个图片区域宽度为720px，高度自适应
          </div>
          <div>
            4.交流动态是预置模块，默认关闭。建议在有打卡心得数据后再开启。可通过拖拽来修改上下位置，
          </div>
        </div>
        <Space className={cx('mb-[16px]')}>
          <Button
            type="primary"
            icon={<PlusSquareOutlined />}
            onClick={() => {
              if (dataSource.length <= 10) {
                setDataSource((prevState) => {
                  const newId = prevState.length + 1;
                  prevState.push({
                    id: newId,
                    name: `宣传图${newId - 1}`,
                    mode: 'promotionalImages',
                    index: newId,
                  });
                  setTimeout(() => {
                    const dom = document.querySelector(`[data-id="${newId}"]`);
                    if (dom) {
                      dom.scrollIntoView();
                    }
                  }, 500);
                  return [...prevState];
                });
              } else {
                message.warning('最多支持添加10组宣传图');
              }
            }}
          >
            添加宣传图
          </Button>
          <span className="text-c0c0c0">上下拖拽可对模块进行排序</span>
        </Space>
      </div>
      <div className={styles.card_wrapper}>
        <DndContext
          modifiers={[restrictToVerticalAxis]}
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            // rowKey array
            items={dataSource.map((item) => item.id)}
            strategy={verticalListSortingStrategy}
          >
            {dataSource.map((item, index) => (
              <SortableItem id={item.id} key={item.id}>
                <ImageModule
                  id={item.id}
                  onChecked={(id, checked) => {
                    const idx = dataSource.findIndex((item) => item.id === id);
                    console.log('idx', idx);
                    if (idx > -1) {
                      setDataSource((prevState) => {
                        prevState.splice(idx, 1, { ...dataSource[idx], checked });
                        return [...prevState];
                      });
                    }
                  }}
                  onUrlChange={(id, type, url) => {
                    console.log('onUrlChange调用');
                    console.log(id, url, type);
                    const idx = dataSource.findIndex((item) => item.id === id);
                    if (idx > -1) {
                      setDataSource((prevState) => {
                        prevState.splice(idx, 1, { ...dataSource[idx], [type]: url });
                        return [...prevState];
                      });
                    }
                  }}
                  onNameChange={(id, value) => {
                    // 检查是否有重名
                    const findSameName = dataSource.find(
                      (item) => item.name === value && item.id !== id,
                    );
                    if (!findSameName) {
                      const idx = dataSource.findIndex((item) => item.id === id);
                      if (idx > -1) {
                        setDataSource((prevState) => {
                          prevState.splice(idx, 1, { ...dataSource[idx], name: value });
                          return [...prevState];
                        });
                      }
                      return true;
                    }
                    return false;
                  }}
                  onDelete={(id) => {
                    const idx = dataSource.findIndex((item) => item.id === id);
                    if (idx > -1) {
                      setDataSource((prevState) => {
                        prevState.splice(idx, 1);
                        return [...prevState];
                      });
                    }
                  }}
                  key={item.id}
                  name={item.name}
                  pcUrl={item.pcUrl}
                  mobileUrl={item.mobileUrl}
                  checked={item.checked}
                  mode={item.mode as 'dynamicCommunication' | 'promotionalImages'}
                />
              </SortableItem>
            ))}
          </SortableContext>
        </DndContext>
      </div>
    </div>
  );
};
export default RecruitPageSettings;
